import React from "react";

const DONOTCOMEBACK: React.FC = () => {
    return (
        <section style={{ marginBottom: "40px", fontFamily: "Times New Roman, Times, serif" }}>
            <h1>You've escape... Do not come back...</h1>
            <p style={{ maxWidth: "600px", textAlign: "justify", margin: "0 auto", lineHeight: "1.8" }}>

            </p>
        </section>
    );
};

export default DONOTCOMEBACK;
